import { isAxiosError } from "axios";
import { apiClient } from "./api";
import { Solicitud } from "@/interfaces/prestacionInterface";
import { UUID } from "crypto";

class PrestacionService {
    private basicURL: string;
    private solicitudURL : string;
  
    constructor() {
      this.basicURL = "/Practica";
      this.solicitudURL = "/Solicitud";
    }

    async getPracticas(obraSocialId: string, profesionId: string){
        const endpoint = `${this.basicURL}/GetPracticas`;
        const body = JSON.stringify({
          idOS: obraSocialId,
          idProfesion: profesionId
        });
        try {
            const response = await apiClient.post(endpoint,body);
            return response;
        } catch (error : unknown) {
            if (isAxiosError(error)) {
              return error.response;
            }
            return "Error al traer la lista de prestaciones";
        }
    }

    async getPracticasPesadas(obraSocialId: string, profesionId: string){
      const endpoint = `${this.basicURL}/GetPracticasPesadas`;
      const body = JSON.stringify({
        idOS: obraSocialId,
        idProfesion: profesionId
      });
      try {
          const response = await apiClient.post(endpoint,body);
          return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al traer la lista de prestaciones pesadas";
      }
    }

    async getCopagoPractica(obraSocialId: string, practicaId: string){
      const endpoint = `${this.basicURL}/GetCopagoPractica`;
      const body = JSON.stringify({
        obraSocialId: obraSocialId,
        practicaId: practicaId
      });
      try {
          const response = await apiClient.post(endpoint,body);
          return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al traer el copago de la practica";
      }
    }

    async getPracticasPorObraSocial(obraSocialId: number, planId: number){
      const endpoint = `${this.basicURL}/GetPracticasPorObraSocial`;
      const body = JSON.stringify({
        obraSocialId: obraSocialId, 
        planId: planId
      });
      try {
          const response = await apiClient.post(endpoint, body);
          return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al traer la lista de practicas por obra social y plan";
      }
    }//no lo uso 

    async postSolicitud(solicitud: Solicitud){
      const endpoint = `${this.solicitudURL}/AgregarSolicitud`;
      const body = JSON.stringify(solicitud);
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al crear una solicitud";
      }
    }

    async postPracticaPesada(pesada: Solicitud){
      const endpoint = `${this.solicitudURL}/AgregarPracticaPesada`;
      const body = JSON.stringify(pesada);
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al crear una solicitud";
      }
    }

    async postBonoAdicional(bono: Solicitud){
      const endpoint = `${this.solicitudURL}/AgregarBonoAdicional`;
      const body = JSON.stringify(bono);
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al crear el bono adicional";
      }
    }

    async autorizarSolicitud(idSolicitud: string, username: string){
      const endpoint = `${this.solicitudURL}/AutorizarSolicitud`;
      const body = JSON.stringify({idSolicitud: idSolicitud, username: username});
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al autorizar la solicitud";
      }
    }

    async rechazarSolicitud(idSolicitud: string, username: string, motivo: string){
      const endpoint = `${this.solicitudURL}/RechazarSolicitud`;
      const body = JSON.stringify({
        idSolicitud: idSolicitud, 
        username: username, 
        motivo: motivo
      });
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al rechazar la solicitud";
      }
    }

    async observarSolicitud(idSolicitud: string, username: string, motivo: string){
      const endpoint = `${this.solicitudURL}/ObservarSolicitud`;
      const body = JSON.stringify({
        idSolicitud: idSolicitud, 
        username: username, 
        motivo: motivo
      });
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al observar la solicitud";
      }
    }

    async anularSolicitud(idSolicitud: string, username: string, motivo: string){
      const endpoint = `${this.solicitudURL}/AnularSolicitud`;
      const body = JSON.stringify({idSolicitud: idSolicitud, username: username, motivo: motivo});
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al anular la solicitud";
      }
    }

    async agregarArchivosASolicitud(solicitudArchivos: object){
      const endpoint = `${this.solicitudURL}/AdjuntarDocumentacion`;
      const body = JSON.stringify(solicitudArchivos);
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al agregar imagenes a la solicitud";
      }
    }

    async eliminarArchivoDeSolicitud(archivoAEliminar: object){
      const endpoint = `${this.solicitudURL}/EliminarArchivo`;
      const body = JSON.stringify(archivoAEliminar);
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al eliminar el archivo";
      }
    }

    async getIngresos(){
      const endpoint = `${this.solicitudURL}/GetTiposIngreso`;
      try {
          const response = await apiClient.get(endpoint);
          return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al traer la lista de ingresos";
      }
    }

    async getDiagnosticos(texto: string){
      const endpoint = `${this.solicitudURL}/GetDiagnosticos`;
      const body = JSON.stringify({texto: texto});
      try {
          const response = await apiClient.post(endpoint, body);
          return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al traer la lista de diagnosticos";
      }
    }

    formatTipoIngreso(ingreso: string){
      const nombres = ingreso.split("_");
      const primera_palabra = nombres[0].charAt(0).toUpperCase() + nombres[0].slice(1);
      
      if(nombres.length === 1){
        return primera_palabra;
      }

      const resto_palabras = nombres.slice(1).map((nombre) => {
        return nombre.charAt(0).toLowerCase() + nombre.slice(1).toLowerCase();
      }).join(' ');

      return primera_palabra + ' ' + resto_palabras;
    }

    async getSolicitudesFacturador(idFacturador: string, fechaDesde: string, fechaHasta: string){
      const endpoint = `${this.solicitudURL}/GetSolicitudesFacturador`;
      const body = JSON.stringify({
        idFacturador: idFacturador,
        fechaDesde: fechaDesde,
        fechaHasta: fechaHasta
      });
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al crear una solicitud";
      }
    }

    async getSolicitudesFacturadorNuevo(idFacturador: string, fechaDesde: string, fechaHasta: string, estados: string[], texto: string, sinDocu: boolean,obraSocialId: string, tiposSolicitudValues: [], pagina: number){
      const endpoint = `${this.solicitudURL}/GetSolicitudesFacturador`;
      const body = JSON.stringify({
        idFacturador: idFacturador,
        fechaDesde: fechaDesde,
        fechaHasta: fechaHasta,
        estados: estados,
        texto: texto,
        filtroSinTiposDocumentacion: sinDocu,
        obraSocialId: obraSocialId,
        filtroTiposSolicitud: tiposSolicitudValues,
        pagina: pagina
      });
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al traer solicitudes del facturador.";
      }
    }

    async getSolicitudesPesadasFacturador(username: string, fechaDesde: string, fechaHasta: string, estados: string[], texto: string, sinDocu: boolean,obrasSocialesIds: [], tiposSolicitudValues: [], facturadoresId: string[], pagina: number){
      const endpoint = `${this.solicitudURL}/GetSolicitudesPesadasFacturadores`;
      const body = JSON.stringify({
        username: username,
        fechaDesde: fechaDesde,
        fechaHasta: fechaHasta,
        estados: estados,
        texto: texto,
        filtroSinTiposDocumentacion: sinDocu,
        idsObrasSociales: obrasSocialesIds,
        idsFacturadores: facturadoresId,
        filtroTiposSolicitud: tiposSolicitudValues,
        pagina: pagina
      });
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al traer practicas pesadas de los distintos facturadores.";
      }
    }

    async getSolicitudesObraSocial(username: string, fechaDesde: string, fechaHasta: string, estados: string[], texto: string, sinDocu: boolean,obraSocialId: string, pagina: number, facturadoresId: string[]){
      const endpoint = `${this.solicitudURL}/GetSolicitudesObraSocial`;
      const body = JSON.stringify({
        username: username,
        fechaDesde: fechaDesde,
        fechaHasta: fechaHasta,
        estados: estados,
        texto: texto,
        filtroSinTiposDocumentacion: sinDocu,
        idsObrasSociales: [obraSocialId],
        pagina: pagina,
        idsFacturadores: facturadoresId
      });
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al traer practicas de una obra social.";
      }
    }

    async getSolicitudes(fechaDesde: string, fechaHasta: string, estados: string[], texto: string, sinDocu: boolean,obraSocialesIds: string[],tiposSolicitudValues: [], facturadoresId: string[], pagina: number){
      const endpoint = `${this.solicitudURL}/GetSolicitudes`;
      const body = JSON.stringify({
        username: null,
        fechaDesde: fechaDesde,
        fechaHasta: fechaHasta,
        estados: estados,
        texto: texto,
        filtroSinTiposDocumentacion: sinDocu,
        idsObrasSociales: obraSocialesIds,
        idsFacturadores: facturadoresId,
        filtroTiposSolicitud: tiposSolicitudValues,
        pagina: pagina
      });
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al traer practicas de una obra social.";
      }
    }

    async getObservaciones(idSolicitud: string){
      const endpoint = `${this.solicitudURL}/GetObservaciones`;
      const body = JSON.stringify({idSolicitud: idSolicitud});
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al traer las observaciones";
      }
    }

    async cambiarObservacion(idObservacion: string){
      const endpoint = `${this.solicitudURL}/ResolverObservacion`;
      const body = JSON.stringify({idObservacion: idObservacion});
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al cambiar la observacion";
      }
    }

    async actualizarToken(idSolicitud: UUID, token: string, username: string){
      const endpoint = `${this.solicitudURL}/ActualizarToken`;
      const body = JSON.stringify(
      {
        idSolicitud: idSolicitud,
        token: token,
        username: username
      });
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al actualizar el token";
      }
    }

    async generarPDF(idSolicitud: UUID){
      const endpoint = `${this.solicitudURL}/ImprimirBonoAtencion`;
      const body = JSON.stringify({idSolicitud: idSolicitud});
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al generar el PDF";
      }
    }
    async reporteDiarioTandil(cuit:string, fechaDesde:Date, fechaHasta: Date){
      console.log(fechaHasta);
      const endpoint = `${this.solicitudURL}/GenerarExcelDetalladoCuitTandil`;
      fechaDesde.setDate(fechaDesde.getDate() - 1);
      fechaDesde.setHours(21, 0, 0, 0);
      const fechaDesdeIso = fechaDesde.toISOString();
      fechaHasta.setHours(20, 59, 59, 999);
      const fechaHastaIso = fechaHasta.toISOString();
      const body = JSON.stringify(
        {
          fechaDesde: fechaDesdeIso,
          fechaHasta: fechaHastaIso,
          cuit: cuit,
          asunto: "",
          contenido: "",
          destino: "",
          mandarMail: false,
          estados: ["Autorizada"]
        });
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al generar el reporte diario para el cuit: "+cuit;
      }
    }

    async pasarSolicitudAFacturable(idSolicitud: string, username: string){
      const endpoint = `${this.solicitudURL}/PasarSolicitudAFacturable`;
      const body = JSON.stringify({idSolicitud: idSolicitud, username: username});
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al pasar la solicitud a facturable";
      }
    }

    async getEstados(){
      const endpoint = `${this.solicitudURL}/GetEstadosSolicitudes`;
      try {
          const response = await apiClient.get(endpoint);
          return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al traer la lista de estados";
      }
    }

    async realizarSolicitudAltaComplejidad(idSolicitud: string, username: string, token: string){
      const endpoint = `${this.solicitudURL}/RealizarAltaComplejidad`;
      const body = JSON.stringify({
        idSolicitud: idSolicitud,
        username: username,
        token: token
      });
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al realizar la solicitud de alta complejidad";
      }
    }

    async getTiposSolicitud(){
      const endpoint = `${this.solicitudURL}/GetFiltroTiposSolicitud`;
      try {
          const response = await apiClient.get(endpoint);
          return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al traer la lista de tipos de solicitud";

      }
    }

    async enviarAuditoriaIOMA(idSolicitud: string){
      const endpoint = `${this.solicitudURL}/EnviarAuditoriaIOMA`;
      const body = JSON.stringify({
        solicitudId: idSolicitud,
        motivo: "Enviado a auditoría el dia " + new Date().toLocaleDateString()
      })
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al enviar la solicitud a auditoria IOMA";
      }
    }
    async modificarEfector(idSolicitud: string, idProfesional: string, idEspecialidad: string){
      const endpoint = `${this.solicitudURL}/ModificarEfector`;
      const body = JSON.stringify({
        SolicitudId: idSolicitud,
        NuevoEfectorId: idProfesional,
        NuevaEspecialidadId: idEspecialidad
      });
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al modificar el efector de la solicitud";
      }
    }

    async obtenerValorizacionIOMA(idSolicitud: string){
      const endpoint = `${this.solicitudURL}/GetValorizacionIOMA`;
      const body = JSON.stringify({id: idSolicitud});
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al obtener la valorizacion de IOMA";
      }
    }
    
    async enviarARealizarIOMA(IdSolicitud: string, NuevoEfectorId: string, NuevaEspecialidadEfectorId: string){
      const endpoint = `${this.solicitudURL}/Realizar`;
      const body = JSON.stringify({
        IdSolicitud: IdSolicitud,
        token: "0", // Token hardcodeado por ahora
        NuevoEfectorId: NuevoEfectorId,
        NuevaEspecialidadEfectorId: NuevaEspecialidadEfectorId,
      });
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
          if (isAxiosError(error)) {
            return error.response;
          }
          return "Error al marcar la solicitud como realizada en IOMA";
      }
    }

    async enviarArchivoIOMA(id: string){
      const endpoint = `${this.solicitudURL}/CargarArchivoEnIOMA`;
      const body = JSON.stringify({
        id: id
      });
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error: unknown) {
          if (isAxiosError(error)){
            return error.response;
          }
          return "Error al enviar el archivo a IOMA";
      }
    }
    
    async informarSolicitudIOMA(Id: string){
      const endpoint = `${this.solicitudURL}/InformarSolicitudIOMA`;
      const body = JSON.stringify({
        Id: Id
      });
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error: unknown) {
          if (isAxiosError(error)){
            return error.response;
          }
          return "Error al facturar la solicitud con IOMA";
      }
    }
}
export default PrestacionService;